"use client"

import { ButtonProps } from "../../ui"
import { isTMA } from "@telegram-apps/bridge"
import { mainButton } from "@telegram-apps/sdk-react"
import { useEffect } from "react"
import { useLatest } from "react-use"
import { useDisabled } from "../../ui"
import { useAccount } from "wagmi"

import { useTgContext } from "./TgRoot"

export interface TgButtonProps extends ButtonProps {
  onClick: () => void
  isVisible?: boolean
  text: string
}

// use htmlType to submit Formik form automatically?
export const TgButton = ({
  onClick,
  isVisible = true,
  disabled,
  text,
  children,
}: TgButtonProps) => {
  const { address } = useAccount()
  const { isSetup, setIsModalOpen } = useTgContext()
  const disabled_ = useDisabled() || disabled
  const lastOnClick = useLatest(onClick)
  useEffect(() => {
    // if blessnet account isn't setup, there's an
    // always on tg button saying "setup blessed account"
    // so we can just skip this altogether
    if (!isTMA("simple") || !isSetup) {
      return
    }

    console.log("setParams button")
    mainButton.setParams({
      isVisible,
      text,
      isEnabled: !disabled_,
      hasShineEffect: !disabled_,
      backgroundColor: disabled_ ? "#CCCCCC" : "#3F49CC",
      textColor: disabled_ ? "#666666" : "#FFFFFF",
    })
    const last = lastOnClick.current
    if (last) {
      mainButton.offClick(last)
    }
    mainButton.onClick(onClick)
    return () => {
      if (last) {
        mainButton.offClick(last)
      }
      mainButton.setParams({
        isVisible: false,
      })
    }
  }, [
    isVisible,
    text,
    onClick,
    disabled_,
    lastOnClick,
    address,
    setIsModalOpen,
    isSetup,
  ])

  if (isTMA("simple")) {
    return null
  }
  return children
}
